import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  labelWidth: '150px',
  formItems: [
    {
      label: '使用人',
      field: 'usedBy',
      type: 'select',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人'
    },
    {
      field: 'date',
      type: 'datepicker',
      label: '日期',
      clearable: false,
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      field: 'chatOnly',
      type: 'switch',
      activeValue: 'on',
      inActiveValue: 'off',
      label: '仅显示有聊天的客户'
    }
  ]
}
